import { render, staticRenderFns } from "./PrivacyStatement.vue?vue&type=template&id=30185568&scoped=true&"
import script from "./PrivacyStatement.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyStatement.vue?vue&type=style&index=0&id=30185568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30185568",
  null
  
)

export default component.exports